export type File = {
  name: string
  status: string
}

export enum Status {
  LOADING = 'Loading',
  ERROR = 'Error',
  LOADED = 'Loaded'
}
